Vue.component('ack-application-workflow-features', {
   delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
   template: '#ack-application-workflow-features',
   mounted() {
 
     
   },
   props:{
      featureItems: { // :product-info
         type: Array,
         required: true
      },
      isMobile: {
        type: Boolean,
        required: true
      }
   },
   computed: {
     //...Vuex.mapGetters('shop', ['productList']),
     
   },
   data() {
     return {

     }
   },
   methods: {
     //...Vuex.mapActions(['sayHi', 'someAction']),
     //...Vuex.mapActions('shop', ['addSelectedItem', 'removeSelectedItem']),
     toggleItem(selectedIndex) {
      // Close all items
      this.featureItems.forEach((item, index) => {
        if (index === selectedIndex) {
          // Toggle the selected item
          this.featureItems[index].open = !this.featureItems[index].open
        } else {
          // Ensure all other items are closed
          this.featureItems[index].open = false
        }
      })
    }
     
 
   },
   beforeDestroy() {
     
   },
   watch: {
    isMobile: {
      handler() {


      },
      deep: false
    }
  }
 })